document.addEventListener('click', function (e) {
    const link = e.target.closest('.hdt-scroll-to-link-same-site');

    if (!link) {
        return;
    }

    e.preventDefault();

    const target = document.querySelector('.' + link.dataset.scrollTarget);

    if (target) {
        const headerOffset = 20;
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
});